module.exports = __webpack_public_path__ + "static/img/mine5.7ce2525.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mine5.jpg
// module id = LGwj
// module chunks = 1